import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { confirm, getMapUrl, promptUser, toHours } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';
import Privacy from '../Common/Privacy';
import ExamAttachmentsList from '../Modules/ExamAttachmentsList';
import FileUpload from '../Modules/FileUpload';

const Session = observer(class Session extends React.Component {
  constructor() {
    super();
    this.showPassword = this.showPassword.bind(this);
    this.minimizeSession = this.minimizeSession.bind(this);
    this.closeSession = this.closeSession.bind(this);
    this.closeCompletedSession = this.closeCompletedSession.bind(this);
    this.handleTabs = this.handleTabs.bind(this);
    this.getRoster = this.getRoster.bind(this);
    this.getIncidents = this.getIncidents.bind(this);
  }

  componentWillMount() {
    const { ManagerStore, SessionStore } = this.props.store;
    const { examSid, sessionSid } = this.props;
    const { installSid } = SessionStore.userData;
    const courseSid = SessionStore.courseData.sid;
    let { session } = this.props;
    
    if(!session) {
      session = ManagerStore.session;
    }

    this.state = {
      activeTab: 0,
      minimize: this.props.minimize,
      showPassword: false,
      mmid: null,
      mmurl: null,
      hideUpload: false
    }

    // Get the current time
    SessionStore.getCurrentTime(true);

    // Hide the upload field if the exam has been returned
    if(session && session.returnedFile && session.returnedFile.file) {
      this.setState({
        hideUpload: true
      });
    }

    // Get the megameeting information for B Virtual sessions
    if(this.props.megameeting) {
      const { installSid, examSid } = this.props;
      const sessionSid = this.props.session.sid;

      ManagerStore.getMMId(installSid, examSid, sessionSid, this, true);
    }

    // Get the session if it isn’t in the props
    if(!this.props.session) {
      const callback = () => {
        ManagerStore.getSessionEnrollment(
          installSid,
          courseSid,
          ManagerStore.session.enrollmentSid,
          null,
          ManagerStore.session
        );
        
        ManagerStore.getSessionExam(
          installSid,
          courseSid,
          examSid,
          null,
          ManagerStore.session
        );
      };
      ManagerStore.getExamSession(installSid, examSid, sessionSid, null, null, callback);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      minimize: nextProps.minimize
    });
  }

  componentWillUnmount() {
    const { ManagerStore } = this.props.store;
    ManagerStore.sessions = [];
  }

  showPassword() {
    this.setState({
      showPassword: !this.state.showPassword
    });
  }

  minimizeSession(accessKey) {
    this.setState({
      minimize: !this.state.minimize
    });

    let minimized = [...this.props.parent.state.minimized];

    minimized.push(accessKey);

    this.props.parent.setState({
      minimized
    });
  }

  closeSession() {
    const { ManagerStore } = this.props.store;
    let sessionSid = null;

    if(this.props.session) {
      sessionSid = this.props.session.sid;
    } else {
      sessionSid = ManagerStore.session.sid;
    }

    ManagerStore.closeExamSession(sessionSid);
  }

  confirmComplete(installSid, examSid, sessionSid) {
    const { translation } = this.props;

    const msg = {
      heading: translation.complete_prompt.heading,
      body: translation.complete_prompt.body,
      button: translation.complete_prompt.button
    }

    confirm(msg, () => this.completeSession(installSid, examSid, sessionSid));
  }

  completeSession(installSid, examSid, sessionSid) {
    const { session } = this.props;
    const { ManagerStore } = this.props.store;

    let callback = null;

    if(session.exam.type.toLowerCase() !== 'written') {
      callback = this.closeCompletedSession;
    } else {
      callback = this.closeWrittenSession;
    }

    ManagerStore.completeExamSession(
      installSid,
      examSid,
      sessionSid,
      callback,
      this.props.session.schedulingModule
    );
  }

  closeCompletedSession() {
    const { session, translation } = this.props;
    const { SessionStore } = this.props.store;

    session.status = 'Closed';

    SessionStore.showToaster(translation.session_closed, 'success');
  }

  closeWrittenSession() {
    const { session, translation } = this.props;
    const { SessionStore } = this.props.store;

    session.status = 'Closed';

    SessionStore.showToaster(translation.session_closed, 'success');
  }

  confirmCancel(sessionSid) {
    const { translation } = this.props;

    const msg = {
      heading: translation.cancel_confirm_prompt.heading,
      body: translation.cancel_confirm_prompt.body,
      button: translation.cancel_confirm_prompt.button
    }

    confirm(msg, () => this.initCancel(sessionSid));
  }

  initCancel(sessionSid) {
    const _this = this;
    const { schedulingModule, translation } = this.props;

    const options = [
      {
        label: translation.cancel_options.helper,
        value: ''
      }, {
        label: translation.cancel_options.no_show,
        value: 'no-show'
      }, {
        label: translation.cancel_options.changed_time,
        value: 'changed-time'
      }, {
        label: translation.cancel_options.technical_issue,
        value: 'technical-issue'
      }, {
        label: translation.cancel_options.other,
        value: 'other-reason'
      }
    ]

    const msg = {
      heading: translation.cancel_prompt.heading,
      options,
      button: translation.cancel_prompt.button
    }

    const setReason = (memo, selectedReason) => {
      const data = {
        cancellationMemo: memo,
        reason: selectedReason,
        schedulingModule
      }

      _this.cancelSession(sessionSid, data)
    }

    promptUser(msg, setReason, null);
  }

  cancelSession(sessionSid, data) {
    const { installSid, session, translation } = this.props;
    const { ManagerStore, SessionStore } = this.props.store;

    const callback = () => {
      SessionStore.showToaster(translation.session_cancelled, 'success');
      session.status = 'Cancelled';
    }

    ManagerStore.cancelExamSession(installSid, session.exam.sid, sessionSid, data, callback);
  }

  handleTabs(index) {
    this.setState({
      activeTab: index
    })
  }

  permittedItems(examConfiguration) {
    const { translation } = this.props;
    if(!examConfiguration){
      examConfiguration = this.props.session.examConfiguration;
    }

    const items = [
      {
        item: 'Bathroom Break',
        permitted: examConfiguration.permittedBathroomBreak,
        notes: examConfiguration.permittedBathroomBreakInformation
      }, {
        item: 'Blank Paper',
        permitted: examConfiguration.permittedBlankPaper,
        notes: examConfiguration.permittedBlankPaperInformation
      }, {
        item: 'Calculator',
        permitted: examConfiguration.permittedCalculator,
        notes: examConfiguration.permittedCalculatorInformation
      }, {
        item: 'Dictionary',
        permitted: examConfiguration.permittedDictionary,
        notes: examConfiguration.permittedDictionaryInformation
      }, {
        item: 'Earplugs',
        permitted: examConfiguration.permittedEarplugs,
        notes: examConfiguration.permittedEarplugsInformation
      }, {
        item: 'Formula Sheets',
        permitted: examConfiguration.permittedFormulaSheet,
        notes: examConfiguration.permittedFormulaSheetInformation
      }, {
        item: 'Notes',
        permitted: examConfiguration.permittedNotes,
        notes: examConfiguration.permittedNotesInformation
      }, {
        item: 'Textbook',
        permitted: examConfiguration.permittedTextbook,
        notes: examConfiguration.permittedTextbookInformation
      }, {
        item: 'Websites',
        permitted: examConfiguration.permittedWebsites,
        notes: examConfiguration.permittedWebsitesInformation
      }
    ]

    let permittedItems = [];

    for(let i = 0; i < items.length; i++) {
      if(items[i].permitted) {
        const permittedItem = React.createElement('li', {key: `${i}`},
          React.createElement('strong', null, `${items[i].item}:`),
          React.createElement('p', null, items[i].notes || translation.permitted_items.permitted)
        );
        permittedItems.push(permittedItem);
      }
    }

    if(examConfiguration.permittedOtherItems) {
      const permittedItem = React.createElement('li', {key: 'other'},
        React.createElement('strong', null, `${translation.permitted_items.other_items}:`),
        React.createElement('p', null, examConfiguration.permittedOtherItems)
      );
      permittedItems.push(permittedItem);
    }

    let itemList = React.createElement('ul', {className: 'data--alt'}, permittedItems);

    if(permittedItems.length > 0) {
      return itemList
    } else {
      return <p><strong>{translation.none}</strong></p>
    }
  }

  getRoster() {
    const query = '?limit=25&roles=instructor';

    this.props.store.EnrollmentStore.getCourseRoster(query, this.props.installSid, this.props.courseSid);
  }

  getIncidents() {
    const { ExamStore, ManagerStore, SessionStore } = this.props.store;;
    let installSid = this.props.installSid;
    let examSid = this.props.examSid;

    let sessionSid = null;

    if(this.props.session) {
      sessionSid = this.props.session.sid;
    }

    if(!installSid) {
      installSid = SessionStore.userData.installSid;
    }

    if(!examSid) {
      examSid = ManagerStore.session.examSid;
    }

    if(!sessionSid) {
      sessionSid = ManagerStore.session.sid;
    }

    ExamStore.getSessionEvents(installSid, examSid, sessionSid);
  }

  reportIncident(sessionSid) {
    const { ManagerStore } = this.props.store;

    ManagerStore.reportIncident = true;
    ManagerStore.incidentSession = sessionSid;
    ManagerStore.incidentSid = null;
  }

  editIncident(sessionSid, incidentSid) {
    const { ManagerStore } = this.props.store;

    ManagerStore.reportIncident = true;
    ManagerStore.incidentSession = sessionSid;
    ManagerStore.incidentSid = incidentSid;
  }

  deleteIncident(incidentSid) {
    const { translation } = this.props;
    const { ManagerStore, SessionStore } = this.props.store;
    let installSid = this.props.installSid;
    let examSid = this.props.examSid;

    let sessionSid = null;

    if(this.props.session) {
      sessionSid = this.props.session.sid;
    }

    if(!installSid) {
      installSid = SessionStore.userData.installSid;
    }

    if(!examSid) {
      examSid = ManagerStore.session.examSid;
    }

    if(!sessionSid) {
      sessionSid = ManagerStore.session.sid;
    }

    const msg = {
      heading: `${translation.delete_incident.heading}?`,
      body: translation.delete_incident.body,
      button: translation.delete_incident.button
    }

    confirm(
      msg,
      () => this.props.store.ExamStore.deleteSessionEvent(
        installSid,
        examSid,
        sessionSid,
        incidentSid
      )
    );
  }

  selectUrl(e) {
    const input = e.target;
    input.setSelectionRange(0, 9999);
  }


  getExamFile() {
    const { ManagerStore } = this.props.store;
    const { session, installSid } = this.props;
    const fileName = `${session.enrollment.firstName} ${session.enrollment.lastName} - ${session.exam.title}`;

    ManagerStore.getExamFile(installSid, session.examConfiguration.sid, session.sid, fileName);
  }

  render() {
    const { translation } = this.props;
    const { EnrollmentStore, ExamStore, ManagerStore, SessionStore } = this.props.store;

    let installSid = this.props.installSid;
    let examSid = this.props.examSid;
    let session = this.props.session;
    let schedulingModule = this.props.schedulingModule;

    // If a data isn’t provided as a prop
    // use the data from the store
    if(!installSid) {
      installSid = SessionStore.userData.installSid;
    }

    if(!examSid && ManagerStore.session) {
      examSid = ManagerStore.session.examSid;
    }

    if(!session) {
      session = ManagerStore.session;
    }

    if(!schedulingModule && ManagerStore.session) {
      schedulingModule = ManagerStore.session.schedulingModule;
    }

  if(!SessionStore.loading || (session && session.enrollment && session.exam)) {

      const { location } = session;
      let address = location ? `${location.address1 || ''} ${location.address2 || ''}` : '';
      
      // Don’t use the default tab styles
      Tabs.setUseDefaultStyles(false);
      

      // Check if session has started
      const now = moment(this.props.store.SessionStore.currentTime);
      const appointmentDate = moment(session.appointmentDate).local();
      const appointmentDiff = moment.duration(appointmentDate.diff(now)).asHours();

    
      return (
        <li className={`panel--medium session ${this.state.minimize ? 'minimized' : ''}`}>
          <article>
            {this.props.multi &&
              <header className="panel__header session__header">
                <h2 className="panel__title">{session.accessKey}</h2>

                <div className="panel__tools">
                  <button
                    className="minimize__btn"
                    onClick={() => {this.minimizeSession(session.accessKey)}}
                  >
                    <span className="meta">{translation.minimize}</span>
                  </button>

                  <button
                    className="minimize__btn minimize__btn--close"
                    onClick={this.closeSession}
                  >
                    <span className="meta">{translation.close}</span>
                  </button>
                </div>
              </header>
            }

            <div className="session__body">
              <h2 className="panel__heading">
                {session.enrollment.firstName}&nbsp;{session.enrollment.lastName}
              </h2>

              {this.props.megameeting &&
                <section className="note session-note">
                  <h5 className="note__heading">{translation.student_url}</h5>

                  <input
                    type="text"
                    value={`https://meeting.onlineproctornow.com/guest/?id=${this.state.mmid}#`}
                    onFocus={(e) => this.selectUrl(e)}
                    readOnly
                  />

                  <a className="btn note__btn" href={this.state.mmurl} target="_blank">{translation.open_meeting}</a>
                </section>
              }

              {/* Close session button (online exams) */}
              {!this.props.noInteract &&
                session.status.toLowerCase() !== 'closed' &&
                session.status.toLowerCase() !== 'cancelled' &&
                session.exam.type.toLowerCase() !== 'written' &&
                appointmentDiff <= -.25 &&

                <section className="session__section">
                  <h4 className="meta">{translation.exam_details.heading}</h4>

                  <div className="btn-group">
                    <button
                      className="btn btn--outline"
                      onClick={() => this.confirmComplete(installSid, examSid, session.sid)}
                    >
                      <icons.iconCheck />
                      {translation.actions.button}
                    </button>
                  </div>
                </section>
              }

              {/* Download written exam button */}
              {
                session.exam.type.toLowerCase() === 'written' &&
                session.status.toLowerCase() !== 'closed' &&
                session.status.toLowerCase() !== 'cancelled' &&
                session.examFile &&

                <button
                  className="btn"
                  href={session.examFile.attachmentUrl}
                  onClick={() => this.getExamFile()}
                  type="button"
                >
                  <icons.iconDownload />
                  {translation.download_exam.button}
                </button>
              }

              {/* Upload written exam button */}
              {!this.props.noInteract &&
                session.exam.type.toLowerCase() === 'written' &&
                appointmentDiff <= -.25 &&

                <section className="session__section">
                  <h4 className="meta">{translation.upload_exam.heading}</h4>

                  {session.returnedFile && session.returnedFile.file &&
                    <div className="text-block text-block--push">
                      <a
                        className="files__title"
                        target="_blank"
                        href={session.returnedFile.file}
                      >
                        <icons.icon_pdf />
                        {translation.returned_file} (

                        {moment.utc(session.returnedFile.createdDate)
                              .local()
                              .tz(moment.tz.guess())
                              .format('M/D/YYYY [at] h:mma')})
                      </a>

                      {this.state.hideUpload &&
                        <button
                          className="btn--link files__new"
                          onClick={() => this.setState({hideUpload: false})}
                        >
                          {translation.upload_exam.new}
                        </button>
                      }
                    </div>
                  }

                  {!this.state.hideUpload &&
                    <FileUpload
                      {...this.props}
                      label={translation.upload_exam.label}
                      helper={translation.upload_exam.helper}
                      onDrop={(attachments) => ManagerStore.returnFiles = attachments}
                      files={this.state.returnFiles}
                      single={true}
                      fileType={'application/pdf'}
                      maxSize={10000000}
                    />
                  }

                  {ManagerStore.returnFiles.length > 0 &&
                    <div className="btn-group file__submit">
                      <button
                        className="btn"
                        onClick={() => {
                          this.setState({hideUpload: true, returnFiles: []});
                          ManagerStore.returnExam(installSid, examSid, session.sid, null, session);
                        }}
                      >
                        <icons.iconUpload />
                        {(!session.returnedFile || !session.returnedFile.file) &&
                          translation.upload_exam.button
                        }

                        {session.returnedFile && session.returnedFile.file &&
                          translation.upload_exam.new_button
                        }
                      </button>
                    </div>
                  }
                </section>
              }

              <Tabs
                className="panel__tabs"
                onSelect={this.handleTabs}
              >
                <TabList className="tabs-enabled">
                  <Tab>{translation.tabs.exam_details}</Tab>
                  <Tab>{translation.tabs.location}</Tab>
                  <Tab>{translation.tabs.notes}</Tab>
                  <Tab onClick={this.getRoster}>{translation.tabs.faculty}</Tab>

                  {!this.props.noInteract &&
                    <Tab onClick={this.getIncidents}>{translation.tabs.incidents}</Tab>
                  }
                </TabList>

                <TabPanel>
                  <h3 className="meta">{translation.exam_details.heading}</h3>

                  <section className="session__section">
                    <h4 className="data-heading">{translation.exam_details.heading}</h4>

                    <ul className="data--alt session__data">
                      <li>
                        <strong>{translation.exam_details.date}:</strong>
                        <p>{moment.utc(session.appointmentDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}</p>
                      </li>
                      <li>
                        <strong>{translation.exam_details.duration}:</strong>
                        {session.examConfiguration.duration >= 60 &&
                          <p>{toHours(session.examConfiguration.duration, false, false, true)}</p>
                        }

                        {session.examConfiguration.duration < 60 &&
                          <p>{session.examConfiguration.duration} {translation.exam_details.minutes}</p>
                        }
                      </li>
                      <li>
                        <strong>{translation.exam_details.title}:</strong>
                        <p>{session.exam.title}</p>
                      </li>
                      <li>
                        <strong>{translation.exam_details.type}:</strong>
                        <p>{session.exam.type}</p>
                      </li>

                      {session.exam.type.toLowerCase() !== 'written' &&
                        <li>
                          <strong>
                            <label htmlFor="session-url">
                              {translation.exam_details.url}:
                            </label>
                          </strong>

                          <input
                            id="session-url"
                            type="text"
                            defaultValue={session.exam.url}
                            readOnly
                            onFocus={(e) => e.target.setSelectionRange(0, 9999)}
                          />
                        </li>
                      }

                      {session.exam.type.toLowerCase() !== 'written' && session.examConfiguration.password &&
                        <li>
                          <strong>{translation.exam_details.password}:</strong>

                          <Privacy
                            className="faux-input faux-input--enabled"
                            show={translation.reveal_password}
                            hide={translation.hide_password}
                            private={session.examConfiguration.password}
                            {...this.props}
                          />
                        </li>
                      }

                    </ul>
                  </section>

                  <section className="session__section">
                    <h4 className="data-heading">{translation.permitted_items.heading}</h4>

                    {this.permittedItems(session.examConfiguration)}
                  </section>

                  {/* Attachments */}
                  {
                    session.examConfiguration.attachments && session.examConfiguration.attachments.length > 0 &&

                    <section className="session__section">
                      <ExamAttachmentsList
                        parent={this}
                        examDashboard={false}
                        {...this.props}
                        exam={session.exam}
                        examConfiguration={session.examConfiguration}
                        sessionManager={true}
                      />
                    </section>
                  }
                </TabPanel>

                <TabPanel>
                  <h3 className="meta">{translation.location_information.heading}</h3>

                  <section className="session__section">
                    <div className="session-detail__location">
                      <ul className="data--alt vcard">
                        <li>
                          <strong>{translation.location_information.address}</strong>
                          <p className="adr">
                            <span className="street-address">{address}</span>
                            <span className="locality">{location.place}</span>
                            <span className="region">{location.region ? `, ${location.region}` : '' }</span>
                            <span className="postal-code"> {location.postalCode}</span>
                            <span className="country">{location.country}</span>
                          </p>
                        </li>
                      </ul>

                      <img
                        className="map--static session-detail__map"
                        width="400" height="250"
                        src={getMapUrl(location.latitude, location.longitude)}
                        alt="A map of the location"
                      />
                    </div>
                  </section>
                </TabPanel>

                <TabPanel>
                  <h3>{translation.notes.proctor_notes}</h3>

                  <p className={session.examConfiguration.proctorNotes ? '' : 'empty'}>
                    {session.examConfiguration.proctorNotes || 'No proctor notes provided.'}
                  </p>

                  <h3>{translation.notes.student_notes}</h3>

                  <p className={session.examConfiguration.studentNotes ? '' : 'empty'}>
                    {session.examConfiguration.studentNotes || 'No student notes provided.'}
                  </p>
                </TabPanel>

                <TabPanel>
                  <h3 className="meta">{translation.faculty.heading}</h3>

                  {EnrollmentStore.courseRoster.length > 0 &&
                    <table>
                      <thead>
                        <tr>
                          <th className="subtitle" scope="col">{translation.faculty.name}</th>
                          <th className="subtitle" scope="col">{translation.faculty.role}</th>
                          <th className="subtitle" scope="col">{translation.faculty.email}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {EnrollmentStore.courseRoster.map(
                          (key, i) =>
                          <tr key={i}>
                            <td>{key.lastName}, {key.firstName}</td>
                            <td className="capitalize">{key.role}</td>
                            <td>{key.email}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  }

                  {EnrollmentStore.courseRoster.length === 0 &&
                    <span className="no-results">{translation.faculty.no_results}</span>
                  }
                </TabPanel>

                {!this.props.noInteract &&
                  <TabPanel>
                    <h3 className="meta">{translation.incidents.heading}</h3>

                    {ExamStore.sessionEvents.length > 0 &&
                      <table>
                        <thead>
                          <tr>
                            <th className="subtitle" scope="col">{translation.incidents.type}</th>
                            <th className="subtitle" scope="col">{translation.incidents.subject}</th>
                            <th className="subtitle" scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ExamStore.sessionEvents.map(
                            (key, i) =>
                            <tr key={i}>
                              <td>{key.eventType.title}</td>
                              <td>{key.subject}</td>
                              <td className="actions">
                                <button
                                  className="btn--outline"
                                  onClick={() => {this.editIncident(session.sid, key.sid)}}
                                >
                                  <icons.iconEdit />
                                  {translation.incidents.edit}
                                </button>

                                <button
                                  className="btn--outline btn--negative"
                                  onClick={() => {this.deleteIncident(key.sid)}}
                                >
                                  <icons.iconTrash />
                                  {translation.incidents.delete}
                                </button>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    }

                    {ExamStore.sessionEvents.length === 0 &&
                      <span className="no-results">{translation.incidents.no_results}</span>
                    }

                    <button
                      className="btn btn--negative"
                      onClick={() => this.reportIncident(session.sid)}
                    >
                      {translation.incidents.report_incident}
                    </button>
                  </TabPanel>
                }
              </Tabs>

              {!this.props.noInteract &&
                session.status.toLowerCase() !== 'closed' &&
                session.status.toLowerCase() !== 'cancelled' &&

                <div className="panel__section">
                  <button
                    className="btn--link negative"
                    onClick={() => this.confirmCancel(session.sid)}
                  >
                    {translation.actions.cancel_button}
                  </button>
                </div>
              }
            </div>
          </article>
        </li>
      )
    }

    return null;
  }
})

export default translate('Session')(Session);



// WEBPACK FOOTER //
// ./src/app/components/Outside/Session.js